// City finder / autocomplete widget for homepage
(function () {
  var PAGES = JSON.parse(document.getElementById('pages-data').textContent);

  var svcSelect = document.getElementById('svc-select');
  var cityInput = document.getElementById('city-input');
  var sugBox = document.getElementById('city-suggestions');
  var finderMsg = document.getElementById('finder-msg');
  var findBtn = document.getElementById('find-btn');

  var activeIdx = -1;
  var currentMatches = [];
  var selectedCitySlug = null;

  function showMsg(txt) {
    finderMsg.textContent = txt;
    finderMsg.classList.remove('hidden');
  }
  function hideMsg() { finderMsg.classList.add('hidden'); }

  function hideSuggestions() {
    sugBox.classList.add('hidden');
    sugBox.innerHTML = '';
    currentMatches = [];
    activeIdx = -1;
  }

  function renderSuggestions(matches) {
    currentMatches = matches;
    activeIdx = -1;
    if (!matches.length) { hideSuggestions(); return; }
    sugBox.innerHTML = matches.map(function (p, i) {
      return '<div class="sug-item" data-idx="' + i + '">' +
        '<span class="sug-city"><strong>' + p.cn + '</strong>, ' + p.st + '</span>' +
        '</div>';
    }).join('');
    sugBox.classList.remove('hidden');
  }

  function pickSuggestion(p) {
    cityInput.value = p.cn + ', ' + p.st;
    selectedCitySlug = p.c;
    hideSuggestions();
    hideMsg();
  }

  function getMatchingPages(q) {
    var svc = svcSelect.value;
    var out = [];
    for (var i = 0; i < PAGES.length; i++) {
      var p = PAGES[i];
      if (svc && !p.svcs.includes(svc)) continue;
      if ((p.cn + ', ' + p.st).toLowerCase().includes(q)) {
        out.push(p);
        if (out.length >= 8) break;
      }
    }
    return out;
  }

  cityInput.addEventListener('input', function () {
    selectedCitySlug = null;
    var q = this.value.trim().toLowerCase();
    if (q.length < 2) { hideSuggestions(); return; }
    renderSuggestions(getMatchingPages(q));
  });

  cityInput.addEventListener('keydown', function (e) {
    if (!currentMatches.length) return;
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      activeIdx = Math.min(activeIdx + 1, currentMatches.length - 1);
      updateActiveClass();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      activeIdx = Math.max(activeIdx - 1, -1);
      updateActiveClass();
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (activeIdx >= 0) pickSuggestion(currentMatches[activeIdx]);
      else if (currentMatches.length === 1) pickSuggestion(currentMatches[0]);
    } else if (e.key === 'Escape') {
      hideSuggestions();
    }
  });

  function updateActiveClass() {
    sugBox.querySelectorAll('.sug-item').forEach(function (el, i) {
      el.classList.toggle('active', i === activeIdx);
    });
  }

  sugBox.addEventListener('mousedown', function (e) {
    var item = e.target.closest('.sug-item');
    if (!item) return;
    e.preventDefault();
    pickSuggestion(currentMatches[+item.dataset.idx]);
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('#city-wrap')) hideSuggestions();
  });

  svcSelect.addEventListener('change', function () {
    selectedCitySlug = null;
    var q = cityInput.value.trim().toLowerCase();
    if (q.length >= 2) renderSuggestions(getMatchingPages(q));
  });

  function goToListing() {
    hideMsg();
    var svc = svcSelect.value;
    if (!svc) { showMsg('Please select a service first.'); svcSelect.focus(); return; }

    var citySlug = selectedCitySlug;

    if (!citySlug) {
      var q = cityInput.value.trim().toLowerCase();
      if (!q) { showMsg('Please enter your city.'); cityInput.focus(); return; }
      var matches = getMatchingPages(q);
      if (matches.length === 1) {
        citySlug = matches[0].c;
      } else if (matches.length > 1) {
        renderSuggestions(matches);
        showMsg('Select a city from the list.');
        cityInput.focus();
        return;
      } else {
        showMsg("We don\u2019t have that city yet\u2014try another nearby city.");
        cityInput.focus();
        return;
      }
    }

    window.location.href = '/best-' + svc + '-' + citySlug + '/';
  }

  findBtn.addEventListener('click', goToListing);
  cityInput.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !currentMatches.length) goToListing();
  });
})();
